/** Only personal exercise routes may bypass the club/team onboarding screen. */
export const isPersonalExerciseWorkspacePath = (pathname: string): boolean =>
  /^\/(?:(?:nl|en)\/)?(?:exercise-editor|exercises)\/?$/.test(pathname);
